export type ThemeMode = 'light' | 'dark'
export type Layout = 'vertical' | 'horizontal'

/** Mesma forma do themeConfig do arsal-drive (templateName: 'SANEAMENTO'). */
const themeConfig = {
  templateName: 'GEFSAN',
  mode: 'light' as ThemeMode,
  layout: 'vertical' as Layout,
  navigationSize: 280,
  collapsedNavigationSize: 84,
  disableRipple: true,
  responsiveFontSizes: true,
}

export default themeConfig
